import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RemindersService {
  private baseUrl: string = environment.apiUrl + 'reminders';

  constructor(
    private http: HttpClient
  ) { }

  sendReminder(orderId: string): Observable<any> {
    let body =
    {
      orderId: orderId
    }
    return this.http.post<any>(`${this.baseUrl}/send-reminder`, body);
  }
}
